/*
 * @Author: Tina Huang
 * @Date: 2024-02-19 10:41:06
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2026-01-29 21:56:55
 * @Description:
 */
import { useEffect, useState, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { Breadcrumb, Col, Row, Tag, Button, Form, Alert, Radio, Select, ColorPicker, Spin, Avatar, Modal, message } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { times, effes, others } from '@/constants/libs'
import CustomizeForm from './CustomizeForm'
import crypto from '@/utils/crypto'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { formatDate } from '@/utils'
import { Link } from 'react-router-dom'

const { Item } = Form

export default function LibEdit() {
  const isMobile = window.innerWidth <= 750
  const { id } = useParams()
  // const navigate = useNavigate()
  const [libItem, setLibItem] = useState<any>()
  const [showSpin, setShowSpin] = useState({ show: false, tip: <></>, indicator: <></> })
  const [showCopyModal, setShowCopyModal] = useState(false)
  const [showVideo, setShowVideo] = useState(false)
  const [wlink, setWlink] = useState<any>('')
  const [blink, setBlink] = useState<any>('')
  const [form] = Form.useForm()
  // const libs = [...times, ...effes, ...others]
  const initialValues = {
    black: 0,
    monday: 1,
    theme: '',
    bg_color: '#1677ff',
    font_color: '#fff',
    highlight: '#77ac98',
    lan: 'en',
    size: 'normal',
    background: 9,
  }
  const [messageApi, contextHolder] = message.useMessage()

  const widgetLink = (type: number, _link: string | undefined) => {
    if (type === 1) {
      return `https://widgets.httishere.xyz${_link}`
    } else {
      return `https://httishere.github.io/notion-widget${_link}`
    }
  }

  useEffect(() => {
    const _libs = [...times, ...effes, ...others]
    const _item = _libs.find((item) => item.id.toString() === id)
    setLibItem(_item)
    setWlink(widgetLink(1, _item?.link))
    setBlink(widgetLink(2, _item?.link))
    form.setFieldsValue({
      bg_color: _item?.bg_color,
      font_color: _item?.font_color,
    })
    _indicator(_item)
  }, [form, id])

  const breads = useMemo(() => {
    return [{ title: '首页', path: '/' }, { title: '配置组件', path: '/libs' }, { title: libItem?.tag }]
  }, [libItem])

  const breadsRender = (item: any, params: any, items: any, paths: any) => {
    const last = items.indexOf(item) === items.length - 1
    return last ? <span>{item.title}</span> : <Link to={paths.join('/')}>{item.title}</Link>
  }

  const _formBox = () => {
    const theme_options = libItem?.theme
      ? libItem.theme.map((item: { key: any; label: any }) => {
          return {
            value: item.key,
            label: item.label,
          }
        })
      : []
    const icons_options = libItem?.icons
      ? libItem.icons.map((item: { key: any; label: any }) => {
          return {
            value: item.key,
            label: item.label,
          }
        })
      : []
    const bg_options = libItem?.background
      ? libItem?.background.map((bg: { key: any; url: string | undefined }) => {
          return {
            value: bg.key,
            label: <Avatar src={bg.url} />,
          }
        })
      : []
    return (
      <div className="pt-4">
        {libItem?.mode === 'all' && (
          <Item label="主题" name="black">
            <Radio.Group buttonStyle="solid">
              <Radio.Button value={0}>默认</Radio.Button>
              <Radio.Button value={1}>暗黑</Radio.Button>
            </Radio.Group>
          </Item>
        )}
        {
          libItem?.lng && (
          <Item label="语言" name="lng">
            <Radio.Group buttonStyle="solid" defaultValue="en">
              <Radio.Button value="cn">中文</Radio.Button>
              <Radio.Button value="en">英文</Radio.Button>
            </Radio.Group>
          </Item>)
        }
        {libItem?.monday && (
          <Item label="起始" name="monday">
            <Radio.Group buttonStyle="solid">
              <Radio.Button value={0}>周日</Radio.Button>
              <Radio.Button value={1}>周一</Radio.Button>
            </Radio.Group>
          </Item>
        )}
        {libItem?.theme && (
          <Item label="风格" name="theme">
            <Select options={theme_options} placeholder="请选择" />
          </Item>
        )}
        {libItem?.icons && (
          <Item label="图标" name="icon">
            <Select options={icons_options} placeholder="请选择" />
          </Item>
        )}
        {!libItem?.color_unset && libItem?.bg_color && (
          <>
            <Item label="背景颜色" name="bg_color">
              <ColorPicker showText />
            </Item>
          </>
        )}
        {libItem?.font_color && (
          <Item label="字体颜色" name="font_color">
            <ColorPicker showText />
          </Item>
        )}
        <CustomizeForm id={Number(id)}  />
        {libItem?.background && (
          <Item label="背景图片" name="background">
            <Radio.Group options={bg_options} />
          </Item>
        )}
      </div>
    )
  }

  const _indicator = (item: any) => {
    const getText = (item: any) => {
      if (item.close) {
        return item?.advance ? 'Coming soon' : '未开放分享'
      } else if (item.expired) {
        let isExpired = new Date() > new Date(item?.expired)
        return isExpired ? '限时分享已结束' : '去创建'
      }
      return '去创建'
    }
    const _text = getText(item)
    console.log(_text)
    if (_text !== '去创建')
      setShowSpin({
        show: true,
        tip: (
          <Link to={'/libs'} className="text-white">
            {_text} ›› 返回
          </Link>
        ),
        indicator: <ExclamationCircleFilled className="text-amber-400" />,
      })
  }

  const onFieldsChange = (done: boolean = false) => {
    if (showSpin.show) return
    // 生成预览链接
    let _link = libItem?.link
    const _p = form.getFieldsValue()
    const __p = toHex(_p)
    if (_p?.theme && libItem?.theme[0]?.link) {
      let _theme = libItem?.theme.find((item: { key: any }) => item.key === _p.theme)
      _link = _theme.link
    }
    const encrypted = crypto.aseEncryptParams(JSON.stringify(__p))
    const _wlink = `${_link}?e=${encrypted}`
    setWlink(widgetLink(1, _wlink))
    setBlink(widgetLink(2, _wlink))
    if (done) {
      setShowCopyModal(true)
    }
  }

  const handleLinkCopy = () => {
    messageApi.success('组件复制成功，快去嵌入到你的页面内吧！')
  }

  const toHex = (obj: any) => {
    ;['bg_color', 'font_color', 'highlight'].map((k) => {
      if (obj[k] && typeof obj[k] !== 'string') {
        obj[k] = `#${obj[k]?.toHex()}`
      }
      return null
    })
    if (obj?.day) {
      obj.day = formatDate(obj.day)
    }
    // if (obj?.date_range) {
    //   obj.date_range[0] = formatDate(obj.date_range[0])
    //   obj.date_range[1] = formatDate(obj.date_range[1])
    // }
    return obj
  }

  const styleProps = {
    title: isMobile ? 'text-xl pb-2' : 'text-3xl pb-4',
  }

  return (
    <>
      {contextHolder}
      <Spin spinning={showSpin.show} size="large" {...showSpin} fullscreen />
      <Breadcrumb items={breads} itemRender={breadsRender} separator="››" />
      <Row className="pt-12">
        <Col span={isMobile ? 24 : 11} className="p-8 rounded-md bg-white">
          <h2 className={styleProps.title}>组件预览</h2>
          <iframe
            title="widget"
            src={`${wlink}${wlink.indexOf('?') > -1 ? '&' : '?'}preview=1`}
            style={{
              width: !isMobile && libItem?.size === 'auto' ? '50%' : '100%',
              minHeight: isMobile ? '30vh' : '60vh',
              margin: '0 auto',
              display: 'block',
            }}
          ></iframe>
        </Col>
        <Col span={isMobile ? 0 : 1}></Col>
        <Col span={isMobile ? 24 : 12} className="p-8 rounded-md bg-white">
          <h2 className={`${styleProps.title} flex items-center`}>
            {libItem?.tag}
            {libItem?.tags && (
              <Tag className="pl-2" bordered={false} color="processing">
                {libItem?.tags}
              </Tag>
            )}
          </h2>
          <div>
            <Form
              name="basic"
              form={form}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 16 }}
              initialValues={initialValues}
              autoComplete="off"
              onFieldsChange={() => onFieldsChange()}
              onFinish={() => onFieldsChange(true)}
            >
              {libItem?.desc && <Alert description={libItem?.desc} type="warning" />}
              {_formBox()}
              <Item wrapperCol={isMobile ? { span: 24 } : { offset: 4, span: 16 }}>
                <Button type="primary" htmlType="submit" className="w-full" size="large" shape="round">
                  立即创建
                </Button>
              </Item>
            </Form>
          </div>
        </Col>
      </Row>
      <Modal
        open={showCopyModal}
        centered
        title="组件使用"
        footer={
          <div>
            <CopyToClipboard text={wlink} onCopy={handleLinkCopy}>
              <Button type="primary" shape="round" block>
                复制组件
              </Button>
            </CopyToClipboard>
            <CopyToClipboard text={blink} onCopy={handleLinkCopy}>
              <Button type="text" shape="round" block className="mt-2">
                备用组件链接
              </Button>
            </CopyToClipboard>
          </div>
        }
        onCancel={() => setShowCopyModal(false)}
      >
        <ul className="leading-8">
          {!showVideo && (
            <>
              <li>第一步：点击下方「复制组件按钮」。</li>
              <li>第二步：打开你需要嵌入的页面（支持Notion，FlowUs，Obsidian，Wolai等），并在相应的位置创建一个空白块。</li>
              <li>
                第三步：在空白块内直接粘贴刚才复制的组件，然后会自动出现操作联想选择<strong>「create embed」或者「网页嵌入」</strong>即可。
              </li>
              <li>第四步：根据需要进行组件大小和位置调整</li>
              <li className="text-center text-blue-500 cursor-pointer" onClick={() => setShowVideo(true)}>
                还不会？我要看视频！！
              </li>
            </>
          )}
          {showVideo && <video src="./assets/embed.mov" controls autoPlay />}
        </ul>
      </Modal>
    </>
  )
}
